import React, { useEffect, useState } from 'react';
import '../AddType/addType.css';
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes } from 'firebase/storage';
import { app } from '../../firebase';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';


const Loader = () => (
  <div className="loader">
    <div className="spinner"></div>
  </div>
);

const AddNewProperty = () => {
  const [propertyName, setPropertyName] = useState('');
  const [typeName, setTypeName] = useState('');
  const [propertyDescription, setPropertyDescription] = useState('');
  const [locationInput, setLocationInput] = useState('');
  const [price, setPrice] = useState('');
  const [file, setFile] = useState(null); 
  const [imageUrl, setImageUrl] = useState(''); 
  const [typeList, setTypeList] = useState ([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    getType();
    if (location.state) {
      setPropertyName(location.state.myData.name);
      setTypeName(location.state.myData.type);
      setPropertyDescription(location.state.myData.description);
      setLocationInput(location.state.myData.location);
      setPrice(location.state.myData.price);
      setImageUrl(location.state.myData.imageUrl || ''); 
    }
  }, [location.state]);

  const getType = () => {
    axios.get('https://pkrealestateapi.onrender.com/type')
        .then(res => {
            console.log(res.data.type);
            setTypeList(res.data.type);
        })
        .catch(err => {
            console.log(err);
        });
};

  const fileHandler = (e) => {
    const selectedFile = e.target.files[0]; 
    setFile(selectedFile);
    if (selectedFile) {
      const url = URL.createObjectURL(selectedFile);
      setImageUrl(url); 
    }
  };

  const submitHandler = async (event) => {
    event.preventDefault();

    let uploadedImageUrl = ''; 

    if (file) {
      const storage = getStorage(app);

      try {
        setLoading(true);

        const myRef = storageRef(storage, `property/${Date.now()}_${file.name}`);
        await uploadBytes(myRef, file);
        uploadedImageUrl = await getDownloadURL(myRef); 

        alert('Upload successful!');
      } catch (error) {
        console.error("Upload failed:", error);
        alert(`Upload failed: ${error.message}`);
        return;
      } finally {
        setLoading(false);
      }
    } else {
      uploadedImageUrl = imageUrl; 
    }

    const token = localStorage.getItem('token');

    try {
      if (location.state) {
        // Update existing property
        const response = await axios.put(`https://pkrealestateapi.onrender.com/property/${location.state.myData._id}`, {
          name: propertyName,
          type: typeName,
          location: locationInput,
          price: price,
          description: propertyDescription,
          imageUrl: uploadedImageUrl 
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        console.log(response.data);
        alert('Update successful!');
        navigate('/admin/dashboard/property');
      } else {
        // Create new property
        const response = await axios.post('https://pkrealestateapi.onrender.com/property', {
          name: propertyName,
          type: typeName,
          location: locationInput,
          price: price,
          description: propertyDescription,
          imageUrl: uploadedImageUrl 
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        console.log(response.data);
        alert('Property added successfully!');
        navigate('/admin/dashboard/property');
      }
    } catch (error) {
      if (error.response) {
        console.error('Server Error:', error.response.status);
        console.error('Error Data:', error.response.data);
        alert(`Server Error: ${error.response.data.message || 'An error occurred. Please try again.'}`);
      } else if (error.request) {
        console.error('Network Error:', error.request);
        alert('Network Error: Unable to reach the server. Please check your connection.');
      } else {
        console.error('Error:', error.message);
        alert(`Error: ${error.message}`);
      }
    }
  };

  return (
    <div className='type-containr'>
      <p>{location.state ? 'Edit Property' : 'Add New Property'}</p>
      <form onSubmit={submitHandler} className='type-form'>
        <input
          value={propertyName}
          onChange={(e) => { setPropertyName(e.target.value); }}
          type='text'
          placeholder='Property Name'
          required
          className='input-field'
        />
        {/* <input
          value={typeName}
          onChange={(e) => { setTypeName(e.target.value); }}
          type='text'
          placeholder='Property Type'
          required
          className='input-field'
        /> */}
        <select onChange={(e)=>{setTypeName(e.target.value)}} value={typeName} >
          <option>select type</option>
          {typeList.map(data=>(
            <option  key={data.id} value={data.name}>{data.name}</option>
          ))}
        </select>
        <input
          value={locationInput}
          onChange={(e) => { setLocationInput(e.target.value); }}
          type='text'
          placeholder='Location'
          required
          className='input-field'
        />
        <input
          value={price}
          onChange={(e) => { setPrice(e.target.value); }}
          type='text'
          placeholder='Price'
          required
          className='input-field'
        />
        <input
          value={propertyDescription}
          onChange={(e) => { setPropertyDescription(e.target.value); }}
          type='text'
          placeholder='Property Description'
          required
          className='input-field'
        />

        
        <input
          onChange={fileHandler}
          type='file'
          accept="image/*"
        />

        
        {imageUrl && (
            <div className="image-preview">
              <img style={{ height: '100px', marginRight: '10px' }} src={imageUrl} alt="Preview" />
            </div>
         )}

         <button className='add-btn' type='submit' disabled={loading}>
           {loading ? <Loader /> : (location.state ? 'Update' : 'Add')}
         </button>
       </form>
     </div>
   );
};

export default AddNewProperty;